import { Controller, useFormContext } from 'react-hook-form'

import { Select } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps,
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import { fieldOptions } from 'modules/expenses/hooks/useExpensesCustomization'

const FIELD_NAME = 'units'

interface Props extends WithFieldPermissionsProps, WithCustomizationFieldsProps {
  setIsCalculatingDistance?: (loading: boolean) => void
}

const UnitsField = ({ isFieldReadOnly, isFieldMandatory, customizationFields }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  const unitOptions = fieldOptions('mileage', 'units', customizationFields).map((option) => ({
    label: option.label,
    value: String(option.value),
  }))

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => (
        <Select
          label={i18n.t('expenses_v2.forms.fields.units.label')}
          options={unitOptions}
          value={field.value}
          onChange={(value: string) => {
            field.onChange(value)
          }}
          error={castError(errors?.units)}
          disabled={isFieldReadOnly}
          required={isFieldMandatory}
        />
      )}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(UnitsField, 'units'))
